module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "NameCard"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.name.value))])]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "column col-2"
  }, [_c('StarRating', {
    attrs: {
      "value": _vm.rating
    },
    on: {
      "change": _vm.starChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns center"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_c('Chat', {
    attrs: {
      "nameRef": _vm.name,
      "addComment": _vm.addComment
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3fd5a4ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = 120
// module chunks = 1